<template>
<div>
  <b-container fluid>
    <b-card>
    <b-row>
        <b-col cols="2">
            <SelectList 
                :options="dateOptions"  
                @select="onSelectDate" 
                :searchable="false" 
                :clearable="false" 
                :disabled="loading"
                :value="date" /> 
        </b-col>
        <b-col cols="2">
            <SelectList 
                :options="statusOptions"  
                @select="onSelectStatus" 
                :searchable="false" 
                :clearable="false" 
                :disabled="loading"
                :value="0" /> 
        </b-col>
        <b-col cols="2">
            <fg-input type="search" :placeholder="$t('drivingCycle.block')" v-model.lazy="filter.block" addon-left-icon="fa fa-filter"></fg-input>
        </b-col>
        <b-col cols="2">
        <fg-input type="search" :placeholder="$t('drivingCycle.vehicle')" v-model.lazy="filter.vehicle" addon-left-icon="fa fa-filter"></fg-input>
        </b-col>
        <b-col cols="2">
            <TimeInput @input="(value) => this.filter.time = value"  format="HH:mm" nowButton resetButton> </TimeInput>
        </b-col>
        
        <b-col >
            <div style="float: right" >
            <b-button class="btn-success btn-report" :disabled="!$UIPrivilege('realtime/drivingCycles', 'update') || !changed || loading || saving" @click="$UIPrivilege('realtime/drivingCycles', 'update') && save()">
                <b-icon v-if="$UIPrivilege('realtime/drivingCycles', 'update')" icon="check" scale="1.3"></b-icon>
                {{ $UIPrivilege('realtime/drivingCycles', 'update') ? $t('button.save') : $t('system.maintenance.labels.updateCyclesNoPerms') }}
            </b-button>
            </div>
        </b-col>

    </b-row>
    <b-row>
        <b-col>
            <RequestInfo type="save" :ok="ok" :error="error" :loader="loading || saving" />
        </b-col>
    </b-row>

    <!--
    <hr> -->

    <b-row style="margin-top: 20px;">
         <b-col>
            <!--
            <RequestInfo v-if="loading" :loader="loading" />
            <DrivingCycleTable v-else ref="table" :item="date" :filter="filter" @changed="changed = true" @saved="changed = false; ok = true; loading = false"/>
            -->
             <DrivingCycleTable v-if="!loading" ref="table" :item="date" :filter="filter" @changed="changed = true" @saved="changed = false; ok = true; saving = false"/>
         </b-col>
    </b-row>
                
    </b-card>
  </b-container>


</div>
</template>

<script>

import DrivingCycleTable from '@/components/Realtime/DrivingCycleTable.vue'
import realtime from '@/store/realtime/realtime'
import TimeInput from '@/components/Generic/TimeInput.vue'

export default {
    name: 'DrivingCycles',
    components: {
        DrivingCycleTable, TimeInput
    },
    data: function() {
        return {
            item: {},
            loading: true,
            dateList: [],
            date: null,
            filter: {  
                block: null, vehicle: null, status: null, time: null 
            },
            statusOptions: [
                { id:DrivingCycleTable.VehicleAssignedEnum.ALL, label: this.$t('drivingCycle.status.all'), icon: 'list' },
                { id:DrivingCycleTable.VehicleAssignedEnum.VEHICLE, label: this.$t('drivingCycle.status.vehicle'), icon: 'check-square-fill', variant: 'success' },
                { id:DrivingCycleTable.VehicleAssignedEnum.NO_VEHICLE, label: this.$t('drivingCycle.status.no_vehicle'), icon: 'exclamation-square-fill', variant: 'danger' }
            ],
            changed: false,
            ok: false,
            error: false,
            saving: false
        }
    },
    computed: {
        items () { 
            return this.$store.state.realtime.drivingCycles.list;
        },
        dateOptions(){
            var options = [];
            for(var d of this.dateList){
               options.push( { id: d.date, label: d.date, icon: "calendar2-date" } );                
            }
            return options;
        }
    },
    beforeCreate() {
        if (!this.$store.state.realtime) {
            this.$store.registerModule("realtime" , realtime);
        }
        this.$store.dispatch('realtime/getDrivingCycles').then(response => {
            var datelist = [];
            var isFirstDate = true;

            for (var a of response.data) {
                var previousDate = this.getDate(a.blockSequences[0].startTime);
                
                for (var b of a.blockSequences) {
                    var bDate = this.getDate(b.startTime);
                
                    if (bDate !== previousDate || isFirstDate) {
                        datelist.push({id: b.id, date: bDate});
                        previousDate = this.getDate(b.startTime);
                        isFirstDate = false;
                        
                    }
                }
            }
            this.dateList = datelist;

            let currentDate =  this.getCurrentDate();
            let selectedDate = this.dateList.find( d => d.date == currentDate);
            if(!selectedDate) selectedDate =  datelist[0];
            this.date = selectedDate.date;
        })
       .finally(() => { 
            this.loading = false; 
        });
    },
    methods: {
        getDate(item) {
            var timeArray = item.split("T")[0].split(":");                       
            return timeArray[0];
        },
        getCurrentDate(){
            let date = new Date();
            var dd = String(date.getDate()).padStart(2, '0');
            var mm = String(date.getMonth() + 1).padStart(2, '0'); 
            var yyyy = date.getFullYear();
            return yyyy + "-" + mm + "-" + dd;
        },

        getDay(item) {
            var dateArray = item.split("-");                       
            return dateArray[2] + "." + dateArray[1];
        }, 
        idGenerator: function(item, index) {
            return "Id" + item.id + index;
        },
        onSelectDate(val){
            this.date = val;
        },
        onSelectStatus(val){
            this.filter.status = val;
        },
        save(){
            this.ok = false;
            this.saving = true;
            this.$refs.table.save();
        }
    }
}
</script>
